import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { SurveyStepService } from '../../../src/data/services/survey_step_service';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';

export class MajorSurveyStepController {
  private iconTheme: string;
  private isMobile: boolean;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngSurveyStepService: SurveyStepService,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration,
    private myIntakeModel: any
  ) {
    this.ngSurveyStepService.initialize(this.$stateParams.pageIndex);
    this.iconTheme = this.ngMajorExplorerCapabilityConfiguration.config.navIconTheme;
    this.isMobile = this.ngMajorExplorerCapabilityConfiguration.config.isMobile;
  }

  getPageTitle(): string {
    // convert <br> to spaces and remove any other HTML tags
    const fetchedPageTitle = this.myIntakeModel
      .getCurrentPage()
      .sub_title.replace(/(<br\/?>)/gi, ' ')
      .replace(/(<([^>]+)>)/gi, '');
    return _4.isEmpty(fetchedPageTitle) ? 'Major Explorer' : fetchedPageTitle;
  }

  exitSurvey(): void {
    this.$state.go('my.majorexplorer');
  }

  isDesktop(): boolean {
    return PlatformUtility.isDesktop();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/views/major_survey_step/major_survey_step_controller.ts